// DB ENUM fr.gestionpial.user.dto.EmailAvailability generated by ic2 no-version-available at Thu Oct 01 15:16:31 UTC 2026

import { mapping } from '@ic2/ic2-lib';

export class EmailAvailability {
  static readonly enum: boolean = true;
  static readonly __ic2_fqn: string = 'fr.gestionpial.user.dto.EmailAvailability';

  constructor(public id: number, public lib: string, public name: string) {
  }

  static readonly NOT_AVAILABLE = new EmailAvailability(1, "Not available", "NOT_AVAILABLE");
  static readonly ACCOUNT_CREATION = new EmailAvailability(3, "Account creation", "ACCOUNT_CREATION");

  static readonly values = [
    EmailAvailability.NOT_AVAILABLE,

    EmailAvailability.ACCOUNT_CREATION

  ];

  public toString(): string {
    return this.lib;
  }
  public static map(name: string) {
    for (const e of EmailAvailability.values)
      if (e.name === name)
        return e;
    return null;
  }
  public static mapFromId(id: number) {
    for (const key of EmailAvailability.values)
      if (key.id === id)
        return key;
    return null;
  }
}

mapping['fr.gestionpial.user.dto.EmailAvailability'] = EmailAvailability;
